import { useEffect, useState } from 'react';

export enum ORIENTATION {
	// eslint-disable-next-line @typescript-eslint/naming-convention
	landscape = 'landscape',
	// eslint-disable-next-line @typescript-eslint/naming-convention
	portrait = 'portrait',
}

export const useDeviceOrientation = (): ORIENTATION => {
	const [orientation, setOrientation] = useState<ORIENTATION>(
		ORIENTATION.portrait,
	);
	function checkOrientation() {
		if (window.screen.orientation.type.includes('portrait')) {
			setOrientation(ORIENTATION.portrait);
		} else {
			setOrientation(ORIENTATION.landscape);
		}
	}

	useEffect(() => {
		window.screen.orientation.addEventListener('change', checkOrientation);
		checkOrientation();

		return () => {
			window.screen.orientation.removeEventListener('change', checkOrientation);
		};
	}, []);

	return orientation;
};
